import { createSlice } from "@reduxjs/toolkit";
import { Roles } from "../constants";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isLoggedIn: false,
    token: null,
    userInfo: {},
    role: "",
    profile_image: "",
    guest_token: null,
  },
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.role = action.payload.role;
      state.userInfo = action.payload.userInfo;
      state.profile_image = action.payload.profile_image;
      state.guest_token = action.payload.guest_token;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.token = null;
      state.role = "";
      state.userInfo = {};
      state.profile_image = "";
      state.guest_token = null;
    },
    guestLogin(state, action) {
      state.guest_token = action.payload.guest_token;
      state.role = state.role = action.payload.role;
      state.isLoggedIn = true;
    },
    logoutGuest(state) {
      state.guest_token = null;
    },
  },
});

export const { login, logout, guestLogin, logoutGuest } = authSlice.actions;
export default authSlice.reducer;
